// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3Vc6T","file":"styles_file__1QYTG"};